import angular from 'angular';
import directive from './assessment-threats.directive';


export default angular.module('app.components.advisory.bcp.enterpriseThreatAssessment.assessmentThreats', [])
  .directive('bcpAssessmentThreats', directive)
  .name;

console.log('app.components.advisory.bcp.enterpriseThreatAssessment.assessmentThreats created');
